<template>
    <div class="layout-wrapper" :style="{ direction: $i18n.locale === 'ar' ? 'rtl' : 'ltr' }">
        <aside>
            <header v-t="'shopManager'"></header>
            <AMenu mode="inline" theme="dark">
                <AMenuItem key="sub0"  v-if="store.state.user.resource.includes('1570759303100399617')||store.state.user.isAdmin==1">
                    <template #icon>
                        <HomeFilled />
                    </template>
                    <RouterLink :to="{ name: 'summary' }" v-t="'statistics'"></RouterLink>
                    
                </AMenuItem>
                <ASubMenu key="sub6"
                v-if="store.state.user.resource.includes('1570759303100399618')||store.state.user.resource.includes('1570759303100399619')||
                store.state.user.resource.includes('1570759303100399620')||store.state.user.resource.includes('1570759303100399621')||
                store.state.user.resource.includes('1570759303100399622')||store.state.user.isAdmin==1"> 
                    <template #icon  v-if="store.state.user.resource.includes('1570759303100399618')||store.state.user.resource.includes('1570759303100399619')||
                store.state.user.resource.includes('1570759303100399620')||store.state.user.resource.includes('1570759303100399621')||
                store.state.user.resource.includes('1570759303100399622')||store.state.user.isAdmin==1">
                        <EditOutlined />
                    </template>
                    <template #title  v-if="store.state.user.resource.includes('1570759303100399618')||store.state.user.resource.includes('1570759303100399619')||
                store.state.user.resource.includes('1570759303100399620')||store.state.user.resource.includes('1570759303100399621')||
                store.state.user.resource.includes('1570759303100399622')||store.state.user.isAdmin==1">{{ $t('goodsManage')
                    }}</template>

                    <AMenuItem key="21" v-if="store.state.user.resource.includes('1570759303100399619')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'selling' }" v-t="'selling'"></RouterLink>

                    </AMenuItem>
                    <AMenuItem key="25"  v-if="store.state.user.resource.includes('1570759303100399620')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'auditing' }" v-t="'auditing'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="26"  v-if="store.state.user.resource.includes('1570759303100399621')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'repository' }" v-t="'repository'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="20"  v-if="store.state.user.resource.includes('1570759303100399622')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'goodsClassify' }" v-t="'goodsClassify'"></RouterLink>
                    </AMenuItem>

                </ASubMenu>
                <ASubMenu key="sub7" v-if="store.state.user.resource.includes('1570759303100399623')||store.state.user.resource.includes('1570759303100399624')||
                store.state.user.resource.includes('1570759303100399626')||store.state.user.isAdmin==1">
                    <template #icon v-if="store.state.user.resource.includes('1570759303100399623')||store.state.user.resource.includes('1570759303100399624')||
                store.state.user.resource.includes('1570759303100399626')||store.state.user.isAdmin==1">
                        <EditOutlined />
                    </template>
                    <template v-if="store.state.user.resource.includes('1570759303100399623')||store.state.user.resource.includes('1570759303100399624')||
                store.state.user.resource.includes('1570759303100399626')||store.state.user.isAdmin==1" #title>{{ $t('orderManage') }}</template>
                    <AMenuItem key="22" v-if="store.state.user.resource.includes('1570759303100399624')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'allOrder' }" v-t="'allOrder'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="23" v-if="store.state.user.resource.includes('1570759303100399626')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'comment' }" v-t="'commentManage'"></RouterLink>
                    </AMenuItem>
                </ASubMenu>

                <ASubMenu key="sub1" v-if="store.state.user.resource.includes('1570759303100399633')||store.state.user.resource.includes('1570759303100399634')||
                store.state.user.resource.includes('1570759303100399635')||store.state.user.isAdmin==1">
                    <template #icon v-if="store.state.user.resource.includes('1570759303100399633')||store.state.user.resource.includes('1570759303100399634')||
                store.state.user.resource.includes('1570759303100399635')||store.state.user.isAdmin==1">
                        <EditOutlined />
                    </template>
                    <template v-if="store.state.user.resource.includes('1570759303100399633')||store.state.user.resource.includes('1570759303100399634')||
                store.state.user.resource.includes('1570759303100399635')||store.state.user.isAdmin==1" #title>{{ $t('rightsManage') }}</template>
                    <AMenuItem key="5" v-if="store.state.user.resource.includes('1570759303100399634')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'roles' }" v-t="'rolesManage'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="6" v-if="store.state.user.resource.includes('1570759303100399635')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'admin' }" v-t="'adminManage'"></RouterLink>
                    </AMenuItem>
                </ASubMenu>
                <ASubMenu key="sub3" v-if="store.state.user.resource.includes('1570759303100399627')||store.state.user.resource.includes('1570759303100399628')||
                store.state.user.resource.includes('1570759303100399629')||store.state.user.isAdmin==1">
                    <template #icon  v-if="store.state.user.resource.includes('1570759303100399627')||store.state.user.resource.includes('1570759303100399628')||
                store.state.user.resource.includes('1570759303100399629')||store.state.user.isAdmin==1">
                        <EditOutlined />
                    </template>
                    <template  v-if="store.state.user.resource.includes('1570759303100399627')||store.state.user.resource.includes('1570759303100399628')||
                store.state.user.resource.includes('1570759303100399629')||store.state.user.isAdmin==1" #title>{{ $t('runManage') }}</template>
                    <AMenuItem key="13" v-if="store.state.user.resource.includes('1570759303100399628')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'coupon' }" v-t="'couponManage'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="14" v-if="store.state.user.resource.includes('1570759303100399629')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'party' }" v-t="'partyManage'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="17" v-if="store.state.user.resource.includes('1570759303100399629')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'pintuan' }" v-t="'pintuanManage'"></RouterLink>
                    </AMenuItem>
                </ASubMenu>
                <ASubMenu key="sub5"   v-if="store.state.user.resource.includes('1570759303100399630')||store.state.user.resource.includes('1570759303100399631')||
                store.state.user.resource.includes('1570759303100399632')||store.state.user.isAdmin==1">
                    <template #icon v-if="store.state.user.resource.includes('1570759303100399630')||store.state.user.resource.includes('1570759303100399631')||
                store.state.user.resource.includes('1570759303100399632')||store.state.user.isAdmin==1">
                        <EditOutlined />
                    </template>
                    <template v-if="store.state.user.resource.includes('1570759303100399630')||store.state.user.resource.includes('1570759303100399631')||
                store.state.user.resource.includes('1570759303100399632')||store.state.user.isAdmin==1" #title>{{ $t('financeManage') }}</template>
                    <AMenuItem key="15" v-if="store.state.user.resource.includes('1570759303100399631')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'orderDetailA' }" v-t="'orderDetailA'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="16" v-if="store.state.user.resource.includes('1570759303100399632')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'withdrawLog' }" v-t="'withdrawLog'"></RouterLink>
                    </AMenuItem>
                </ASubMenu>
                <ASubMenu key="sub2" v-if="store.state.user.resource.includes('1570759303100399636')||store.state.user.resource.includes('1570759303100399637')||
                store.state.user.resource.includes('1570759303100399638')|| store.state.user.resource.includes('1570759303100399639')||store.state.user.isAdmin==1">
                    <template #icon v-if="store.state.user.resource.includes('1570759303100399636')||store.state.user.resource.includes('1570759303100399637')||
                store.state.user.resource.includes('1570759303100399638')|| store.state.user.resource.includes('1570759303100399639')||store.state.user.isAdmin==1">
                        <EditOutlined />
                    </template>
                    <template v-if="store.state.user.resource.includes('1570759303100399636')||store.state.user.resource.includes('1570759303100399637')||
                store.state.user.resource.includes('1570759303100399638')|| store.state.user.resource.includes('1570759303100399639')||store.state.user.isAdmin==1" #title>{{ $t('shopSettings') }}</template>
                    <AMenuItem key="9" v-if="store.state.user.resource.includes('1570759303100399637')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'baseinfo' }" v-t="'baseInfo'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="11" v-if="store.state.user.resource.includes('1570759303100399638')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'bond' }" v-t="'bond'"></RouterLink>
                    </AMenuItem>
                    <AMenuItem key="10" v-if="store.state.user.resource.includes('1570759303100399639')||store.state.user.isAdmin==1">
                        <RouterLink :to="{ name: 'othersettings' }" v-t="'otherSettings'"></RouterLink>
                    </AMenuItem>
                    
                </ASubMenu>
            </AMenu>
        </aside>
        <section>
            <header :style="{ direction: $i18n.locale === 'ar' ? 'rtl' : 'ltr' }">
                <RouterLink :to="{ name: 'messages' }"  v-if="store.state.user.resource.includes('1570759303100399640')||store.state.user.isAdmin==1">
                    <ABadge :dot="hasNew > 0" :offset="[-5, 3]">
                        <BellFilled :style="{ fontSize: '25px' }" />
                    </ABadge>
                </RouterLink>
                <span>{{ $store.state.user.shopInfo.shopName }}</span>
                <div class="language">
                    <label v-t="'language'"></label>
                    <ASelect style="width:130px" :value="$i18n.locale" @change="changeLanguage"
                        :options="['ar', 'zh', 'en'].map(item => ({ label: $t(item), value: item }))"></ASelect>
                </div>
                <a href="javascript:;;" v-t="'exit'" @click="exit"></a>
            </header>
            <main>
                <ABreadcrumb class="nav" v-if="$route.meta?.routes">
                    <ABreadcrumbItem v-for="code in $route.meta.routes" :key="code">{{ $t(code) }}</ABreadcrumbItem>
                </ABreadcrumb>
                <div class="content" :nobg="$route.meta.nobg">
                    <RouterView />
                </div>
            </main>
        </section>
    </div>
</template>
<!-- 这是全部的菜单 根据数字去匹配显示啥 -->
<!-- 1570759303100399617：运营概况
1570759303100399618：商品管理   
1570759303100399619：出售中
1570759303100399620：审核中
1570759303100399621：仓库中
1570759303100399622：商品分类
1570759303100399623：订单管理
1570759303100399624：所有订单
1570759303100399625：退款订单
1570759303100399626：评价管理
1570759303100399627：运营管理
1570759303100399628：优惠券管理
1570759303100399629：活动管理
1570759303100399630：财务管理
1570759303100399631：订单明显
1570759303100399632：提现记录
1570759303100399633：权限管理
1570759303100399634：角色管理
1570759303100399635：管理员管理
1570759303100399636：商户设置
1570759303100399637：基本信息
1570759303100399638：保证金
1570759303100399639：其他配置
1570759303100399640：消息列表  -->
<script setup>
import { languageKey } from '@/utils/consts';
import { getCurrentInstance, ref } from 'vue';
import { confirm } from '@/utils/common';
import { useStore } from 'vuex';
import { BellFilled, HomeFilled, EditOutlined } from '@ant-design/icons-vue';
import api from '@/api/shop';
const { appContext: { config: { globalProperties: g } } } = getCurrentInstance();

/**
 * vuex对象
 */
const store = useStore();
/**
 * 是否有新消息
 */
const hasNew = ref(0);

const getIsShow = (list) => {
    // store.state.user.resource.includes('1570759303100399618')
    const resource = store.state.user.resource || []
    if (!resource.length) return false
    return list.some(i => resource.some(j => i === j))
}

/**
 * 改变语言
 */
const changeLanguage = v => {
    window.localStorage.setItem(languageKey, v);
    window.location.reload();
}

/**
 * 退出
 */
const exit = async () => {
    try {
        await confirm(g.$t('askExit'));
        store.dispatch('exit');
    } catch (error) { }
}

/**
 * 获取新消息
 */
const getNewMessage = async () => {
    try {
        hasNew.value = await api.unread();
    } catch (error) { }
}

getNewMessage();
</script>

<style lang="scss" scoped>
.layout-wrapper {
    display: flex;
    height: 100%;

    aside {
        width: 220px;
        background: rgba(0, 21, 41, 1);

        header {
            height: 50px;
            background: rgba(0, 40, 77, 1);
            font-size: 20px;
            line-height: 50px;
            text-align: center;
            font-weight: bold;
            color: white;
        }
    }

    section {
        flex: 1;
        background: rgb(240, 242, 245);
        display: flex;
        flex-direction: column;

        header {
            height: 50px;
            background: white;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0 100px;
            font-size: 16px;
            gap: 70px;
            flex-shrink: 0;

            .language {
                display: flex;
                align-items: center;
                gap: 10px;
            }
        }

        main {
            flex: 1;
            padding: 30px;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .nav {
                margin: -20px 0 10px;
            }

            .content {
                flex: 1;
                overflow: auto;
                background: white;
                border-radius: 5px;
                padding: 15px;

                &[nobg] {
                    background: transparent;
                }
            }
        }
    }
}
</style>